import React from 'react';
import './styles/globals.css';
import './styles/theme.css';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Courses from './components/Courses';
import About from './components/About';
import CourseDetails from './components/CourseDetails';
import ContactForm from './components/Contact';


const App: React.FC = () => {
  return (
    <div className="app">
      <Navbar />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/about" element={<About />} />
        <Route path="/courses/:id" element={<CourseDetails />} />
        <Route path="/contact" element={<ContactForm />} />
      </Routes>
    </div>
  );
};

export default App;